module.exports = __webpack_public_path__ + "img/p8-p1-chuan2.69069399.png";